
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Paronychia(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Paronychia"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Paronychia is <b>an infection of the skin around your fingernails and toenails</b>. Bacteria or a type of yeast called Candida typically cause this infection. Bacteria and yeast can even combine in one infection.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Paronychia/1.png")} alt="onycomycosis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>There are two types of paronychia</b></p>
                                <p><b>Acute paronychia:</b> Symptoms of acute paronychia appear over hours or a few days. The
                                    infection is only in the nail fold and doesn’t extend deeper inside the finger or toe.
                                    Symptoms go away with treatment and last less than six weeks.</p>
                                <p><b>Chronic paronychia:</b> Symptoms develop more slowly than acute paronychia, and they
                                    usually last six weeks or longer. Several fingers or toes can be infected at once. A nail fungus
                                    (usually from a type of fungus called candida) may occur along with the bacterialinfection. </p>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p><b>Usually self-diagnosable</b></p>
                                <p>Adjacent tissue is painful, red and swollen. There may be pus.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Paronychia">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Paronychia;